import * as types from 'packages/store/types';
import { PresetsState } from './types';

const initialState: PresetsState = {
    items: null,
    itemIdThatGoingToBeRemoved: null,
    selectedItem: null,
    isFetching: false,
    requestingRename: false,
    options: {
        search: '',
        sort: ['updated', 'DESC'],
        page: 0,
        size: 20,
    },
};

function nullToEmptyArray(arr: any[] | null): any[] {
    return arr ? arr : [];
}

export default function presetsReducer(state: PresetsState = initialState, action: any): PresetsState {
    switch (action.type) {
        case types.PRESETS_START_FETCH:
            return {
                ...state,
                isFetching: true,
                items: action.emptyBeforeFetch ? [] : state.items,
                options: action.options,
            };

        case types.PRESETS_SUCCESS_FETCH:
            return {
                ...state,
                items: [...nullToEmptyArray(state.items), ...action.items],
                isFetching: false,
                totalItems: action.totalItems,
            };
        case types.PRESETS_FAIL_FETCH:
            return {
                ...state,
                isFetching: false,
            };
        case types.PRESETS_RENAME_REQUEST: {
            return {
                ...state,
                requestingRename: true,
            };
        }
        case types.PRESETS_RENAME_SUCCESS: {
            const items = state.items!.map((item: any) =>
                item.id === action.id
                    ? {
                          ...item,
                          name: action.name,
                      }
                    : item,
            );

            return {
                ...state,
                items,
                requestingRename: false,
            };
        }
        case types.PRESETS_RENAME_FAILURE: {
            return {
                ...state,
                requestingRename: false,
            };
        }
        case types.PRESETS_SET_ITEMS:
            return {
                ...state,
                items: action.items,
                selectedItemId: action.selectedItemId,
                totalItems: typeof action.totalItems === 'number' ? action.totalItems : state.totalItems,
            };
        case types.PRESETS_LOCK_ITEM_BEFORE_REMOVAL:
            return {
                ...state,
                itemIdThatGoingToBeRemoved: action.id,
            };
        case types.PRESETS_UNLOCK_ITEM_AFTER_REMOVAL: {
            return {
                ...state,
                itemIdThatGoingToBeRemoved: null,
            };
        }
        case types.PRESETS_REMOVE_ITEM: {
            const newItems = state.items!.filter((item: any) => item.id !== action.id);

            return {
                ...state,
                selectedItemId: null,
                items: newItems,
                totalItems: state.totalItems! - (state.items!.length - newItems.length),
            };
        }
        default:
            return state;
    }
}
